import { useEffect, useState } from 'react';
import { Mail, Linkedin, Instagram, Check } from 'lucide-react';

const contactReasons = [
    'Freelance projects',
    'Full-time roles',
    'Collaborations',
    'Or a simple conversation about design',
];

const socialLinks = [
    {
        href: 'https://www.linkedin.com/in/deepali-agrawal-1910/',
        icon: Linkedin,
        label: 'LinkedIn',
    },
    {
        href: 'https://www.instagram.com/_orange.palette_/',
        icon: Instagram,
        label: 'Instagram',
    },
];

function Contact() {
    const [copied, setCopied] = useState(false);
    const email = 'deepaliagrawal224@gmail.com';

    useEffect(() => {
        document.title = "Contact — Deepali Agrawal";
    }, []);

    const handleCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText(email);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            // Fallback - open email client
            window.location.href = `mailto:${email}`;
        }
    };

    return (
        <div className="section-padding">
            <div className="max-w-3xl">
                {/* Page Title */}
                <h1 className="text-3xl md:text-headline font-fraunces mb-12">
                    Contact
                </h1>

                {/* Intro */}
                <p className="text-xl md:text-2xl font-fraunces text-warm-gray-700 mb-12">
                    If something here resonated with you, I'd love to hear from you.
                </p>

                {/* Reasons to Reach Out */}
                <section className="mb-12">
                    <p className="text-body-lg text-warm-gray-600 mb-6">
                        You can reach out for:
                    </p>

                    <ul className="space-y-3">
                        {contactReasons.map((reason, index) => (
                            <li
                                key={index}
                                className="flex items-start gap-3 text-warm-gray-700"
                            >
                                <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                                <span className="text-body-lg">{reason}</span>
                            </li>
                        ))}
                    </ul>
                </section>

                {/* Contact Methods */}
                <section className="py-12 border-t border-warm-gray-200">
                    <p className="text-body text-warm-gray-600 mb-8">
                        I read every message and respond thoughtfully.
                    </p>

                    {/* Email Button */}
                    <div className="mb-10">
                        <button
                            onClick={handleCopyEmail}
                            className="group flex items-center gap-3 px-6 py-4 bg-cream-dark hover:bg-warm-gray-100 rounded-lg transition-all duration-200 w-full md:w-auto"
                        >
                            <Mail size={24} className="text-warm-gray-600" />
                            <div className="text-left">
                                <span className="block text-sm text-warm-gray-500 mb-1">Email</span>
                                <span className="text-warm-gray-800 font-medium">{email}</span>
                            </div>
                            <span className="ml-auto text-sm text-warm-gray-500">
                                {copied ? (
                                    <span className="flex items-center gap-1 text-accent">
                                        <Check size={16} />
                                        Copied!
                                    </span>
                                ) : (
                                    'Click to copy'
                                )}
                            </span>
                        </button>
                    </div>

                    {/* Social Links */}
                    <div className="flex flex-wrap gap-4">
                        {socialLinks.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 px-5 py-3 border border-warm-gray-200 hover:border-warm-gray-400 rounded-lg transition-colors"
                            >
                                <link.icon size={20} className="text-warm-gray-600" />
                                <span className="text-warm-gray-700">{link.label}</span>
                            </a>
                        ))}
                    </div>
                </section>

                {/* Closing */}
                <section className="pt-12 border-t border-warm-gray-200">
                    <p className="text-xl font-fraunces text-warm-gray-700 italic">
                        Looking forward to connecting.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default Contact;
